__turbopack_context__.v({
  "header": "u_aUCa_header",
  "modeSwitch": "u_aUCa_modeSwitch",
  "oneCol": "u_aUCa_oneCol",
  "section": "u_aUCa_section",
  "title": "u_aUCa_title",
  "twoCol": "u_aUCa_twoCol",
});
